export default __webpack_public_path__ + "static/media/Imagen_testAB.b48fc92c.png";